import {
  Grid2 as Grid,
  IconButton,
  Box,
  Typography,
  Chip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const quickActions = [
  {
    label: "My Permits",
    icon: "/img/quickLinks/myPermits.svg",
    path: "/permits/my-permits",
  },
  {
    label: "Create Permit",
    icon: "/img/quickLinks/createPermit.svg",
    path: "/permits/create",
  },
  { label: "Payments", icon: "/img/quickLinks/payments.svg", path: "/payment" },
  { label: "Users", icon: "/img/quickLinks/users.svg", path: "/subusers" },
  {
    label: "Subscription",
    icon: "/img/quickLinks/subscription.svg",
    path: "/subscription",
  },
  {
    label: "Select Counties",
    icon: "/img/quickLinks/selectCounties.svg",
    path: "/selectcounties",
  },
  {
    label: "Settings",
    icon: "/img/quickLinks/settings.svg",
    path: "/profilesettings",
  },
  {
    label: "Licenses",
    icon: "/img/quickLinks/licenses.svg",
    path: "/contractors",
  },
];

const QuickActionIcons = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession]?.user);
  const theme = useTheme();
  const mobileSize = useMediaQuery(theme.breakpoints.down("sm"));
  const isEnterprise = Boolean(currentUser?.user?.enterprise?.is_enterprise);

  const [hovered, setHovered] = useState(null);

  const navigate = useNavigate();
  const visibleActions = quickActions.filter(
    (action) => !(isEnterprise && action.path === "/subusers"),
  );

  const layoutRows = [
    visibleActions.slice(0, 3),
    visibleActions.slice(3, 5),
    visibleActions.slice(5),
  ];

  return (
    <Grid
      container
      spacing={mobileSize ? 1.25 : 2}
      justifyContent="center"
      mt={{ xs: 1.5, sm: 2 }}
    >
      {layoutRows.map((row, i) => {
        const isMiddleRow = row.length === 2;

        return (
          <React.Fragment key={i}>
            {row.map(({ label, icon, path }) => (
              <Grid
                size={{ xs: isMiddleRow ? 6 : 4, sm: isMiddleRow ? 6 : 4 }}
                key={label}
              >
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Box
                    sx={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                    onMouseEnter={() => setHovered(label)}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <IconButton
                      sx={{
                        width: mobileSize ? 48 : 60,
                        height: mobileSize ? 48 : 60,
                        borderRadius: "50%",
                        backgroundColor: "#f0f0f0",
                        "&:hover": { backgroundColor: "#e0e0e0" },
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "transform 0.2s ease-in-out",
                      }}
                      className="quick-action-icon"
                      onClick={() => {
                        if (
                          currentSession === "privateProviderSession" &&
                          label === "Licenses"
                        ) {
                          navigate("/privateProvider/contractors");
                        } else {
                          navigate(path);
                        }
                      }}
                    >
                      <img
                        src={icon}
                        alt={label}
                        style={{
                          width: hovered === label ? 36 : mobileSize ? 24 : 30,
                          height: hovered === label ? 36 : mobileSize ? 24 : 30,
                          transition: "all 0.2s ease-in-out",
                        }}
                      />
                    </IconButton>

                    {/* Chip outside the IconButton */}
                    {hovered === label && (
                      <Chip
                        label={
                          <Typography fontWeight="bold" variant="body2">
                            {label}
                          </Typography>
                        }
                        size="small"
                        sx={{
                          mt: 1,
                          fontSize: "0.75rem",
                          backgroundColor: "#fff",
                          pointerEvents: "none",
                          boxShadow: "2px 6px 12px rgba(0,0,0,0.4)",
                          zIndex: 9999,
                          position: "absolute",
                          whiteSpace: "nowrap",
                          maxWidth: "8rem",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          bottom: -25,
                        }}
                      />
                    )}
                  </Box>
                </Box>
              </Grid>
            ))}
          </React.Fragment>
        );
      })}
    </Grid>
  );
};

export default QuickActionIcons;
